<template>
    <b-modal v-model="visible" title="Nerladdningsval" @hidden="onModalClose" :no-close-on-backdrop="isLoading" :no-close-on-esc="isLoading" :hide-header-close="isLoading">
        <div v-if="isLoading" class="d-flex justify-content-center align-items-center p-3" style="height: 100px;">
            <Spinner style="width: 30px; height: 30px; color: #007bff; vertical-align: middle;"></Spinner>
            <p class="ml-2 align-self-center">Skapar CSV-fil...</p>
        </div>

        <div v-else>
            <p>
                Resultatet innehåller för många rader för att visas, välj att ladda ner det istället.
            </p>
        </div>
        <template #modal-footer>
            <b-button :disabled="isLoading" variant="success" @click="download">Ladda ner som CSV</b-button>
            <b-button :disabled="isLoading" variant="danger" @click="cancel">Avbryt</b-button>
        </template>
    </b-modal>
</template>

<script>
import Spinner from "@/components/Shared/Spinner/Spinner"
export default {
    name: "SlowQueryModal",
    components: { Spinner },
    props: {
        loading: { type: Boolean, required: false },
        show: {
            type: Boolean,
            required: true,
        },
    },
    watch: {
        show(newVal) {
            this.visible = newVal
        },
        loading(newVal) {
            this.isLoading = newVal
        },
    },
    data() {
        return {
            isLoading: this.loading,
            visible: this.show,
        }
    },
    methods: {
        download() {
            this.$emit("download")
        },
        cancel() {
            this.$emit("cancel")
        },
        onModalClose() {
            this.$emit("cancel")
        },
    },
}
</script>
